export enum FloorplanSchemaVersion {
  LEGACY = 0,
  V2 = 2,
  V3 = 3,
}

/** Length unit for room shell geometry (floorplan V2). */
export enum FloorplanLengthUnit {
  FT = 'ft',
  M = 'm',
}

export enum FloorplanMeasurementSystem {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
}

export const DEFAULT_WALL_THICKNESS_CM = 2
export const DEFAULT_DIVIDER_THICKNESS_CM = 8
export const DEFAULT_PARTITION_HEIGHT_CM = 10
export const DEFAULT_TABLE_SMALL_WIDTH_CM = 28
export const DEFAULT_TABLE_SMALL_DEPTH_CM = 28
export const DEFAULT_TABLE_LARGE_WIDTH_CM = 44
export const DEFAULT_TABLE_LARGE_DEPTH_CM = 44
export const DEFAULT_TABLE_MEDIUM_WIDTH_CM = 36
export const DEFAULT_TABLE_MEDIUM_DEPTH_CM = 36

/** How a room shell was produced (import / capture pipeline). */
export enum FloorplanRoomShellSourceType {
  MANUAL = 'manual',
  IMAGE = 'image',
  SVG = 'svg',
  ROOMPLAN = 'roomplan',
  POLYCAM = 'polycam',
  DXF = 'dxf',
}

export enum FloorplanOpeningKind {
  DOOR = 'door',
  ENTRY = 'entry',
  WINDOW = 'window',
  PASSAGE = 'passage',
}

export enum FloorplanFixtureKind {
  PILLAR = 'pillar',
  BAR = 'bar',
  STAGE = 'stage',
  STAIRS = 'stairs',
  RESTROOM = 'restroom',
}

export enum FloorplanLightingPreset {
  WARM = 'warm',
  COOL = 'cool',
  CLUB = 'club',
  VIP = 'vip',
  DARK = 'dark',
}

export enum FloorplanDecorKind {
  PLANT = 'plant',
  ROPE = 'rope',
  DJ_BOOTH = 'djBooth',
  ART = 'art',
  CURTAIN = 'curtain',
  BAR = 'bar',
  STAGE = 'stage',
  RESTROOM = 'restroom',
  ENTRANCE = 'entrance',
}

/** Discriminator for objects inside `FloorplanDocument.objects`. */
export enum FloorplanObjectType {
  TABLE = 'table',
  SECTION = 'section',
  LABEL = 'label',
  DECOR = 'decor',
  LIGHTING_ZONE = 'lightingZone',
}

export enum FloorplanViewAngle {
  TOP = 'top',
  ISO = 'iso',
}

export enum FloorplanHistoryEventType {
  DRAFT_SAVE = 'draft_save',
  PUBLISH = 'publish',
  VERSION_RESTORE = 'version_restore',
}

export enum FloorplanHistorySource {
  MANUAL = 'manual',
  AUTOSAVE = 'autosave',
  SYSTEM = 'system',
}

/** Which floorplan document tier a history snapshot stores. */
export enum FloorplanKind {
  V2_IMAGE = 'v2_image',
  V3_DOCUMENT = 'v3_document',
}
